import React, { useState } from 'react';
import * as PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import './AcceptTerms.css';
import {
  Button, Row, Typography, Checkbox, message, Carousel,
} from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { selectSessionUser } from '../../state/ui/application/sessionUiReducer';
import { requestSignOut } from '../../state/ui/application/sessionUiActions';
import { requestAcceptTermsAndConditions } from '../../state/ui/login/loginUiActions';
import { selectAcceptTermsRequest } from '../../state/ui/login/loginUiReducer';
import { legalRoutes } from '../../utility/route-locations';

const { Text } = Typography;


function AcceptTerms({
  sessionUser,
  onSignOut,
  carouselRef,
  acceptTermsAndConditions,
  loading,
}) {
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [acceptedPrivacy, setAcceptedPrivacy] = useState(false);
  const [acceptedEndUser, setAcceptedEndUser] = useState(false);

  const intl = useIntl();
  const termsAcceptedOnServer = sessionUser ? sessionUser.termsToAccept.termsOfUseToAccept === null : false;
  const privacyAcceptedOnServer = sessionUser ? sessionUser.termsToAccept.privacyPolicyToAccept === null : false;
  const eulaAcceptedOnServer = sessionUser ? sessionUser.termsToAccept.eulaToAccept === null : false;

  const allTncsAcceptedClient = sessionUser
    && (acceptedTerms || termsAcceptedOnServer)
    && (acceptedPrivacy || privacyAcceptedOnServer)
    && (acceptedEndUser || eulaAcceptedOnServer);

  const signOut = () => {
    carouselRef.current.goTo(0, false);
    setTimeout(() => {
      onSignOut();
    }, 150);
  };

  const sendAcceptance = () => {
    if (allTncsAcceptedClient) {
      acceptTermsAndConditions(
        acceptedTerms ? sessionUser.termsToAccept.termsOfUseToAccept : null,
        acceptedPrivacy ? sessionUser.termsToAccept.privacyPolicyToAccept : null,
        acceptedEndUser ? sessionUser.termsToAccept.eulaToAccept : null,
        signOut,
      );
    } else {
      message.error(intl.formatMessage({ id: 'termsAccept' }));
    }
  };
  if (!sessionUser) {
    return null;
  }


  const termsOfUseCheck = (!termsAcceptedOnServer) ? (
    <Row>
      <Checkbox className="checkbox-row" onChange={e => setAcceptedTerms(e.target.checked)}>
        <FormattedMessage id="iAgree" />
        <Link to={legalRoutes.terms_of_use} target="_blank"><FormattedMessage id="termsOfUse" /></Link>
      </Checkbox>
    </Row>
  ) : null;

  const privacyCheck = (!privacyAcceptedOnServer) ? (
    <Row>
      <Checkbox className="checkbox-row" onChange={e => setAcceptedPrivacy(e.target.checked)}>
        <FormattedMessage id="iAgree" />
        <Link to={legalRoutes.privacy_policy} target="_blank"><FormattedMessage id="privacyPolicy" /></Link>
      </Checkbox>
    </Row>
  ) : null;

  const endUserCheck = (!eulaAcceptedOnServer) ? (
    <Row>
      <Checkbox className="checkbox-row" onChange={e => setAcceptedEndUser(e.target.checked)}>
        <FormattedMessage id="iAgree" />
        <Link to={legalRoutes.eula} target="_blank"><FormattedMessage id="endUserLicence" /></Link>
      </Checkbox>
    </Row>
  ) : null;

  return (
    <div>
      <Text className="margin-bot"><FormattedMessage id="acceptTerms" /></Text>
      <Row type="flex">
        <div className="centraldiv">
          {termsOfUseCheck}
          {privacyCheck}
          {endUserCheck}
        </div>
      </Row>
      <Button
        className="app-login-button"
        type="primary"
        block
        onClick={sendAcceptance}
        loading={loading}
        htmlType="submit"
      >
        <FormattedMessage id="continue" />
      </Button>
      <Button
        className="app-login-button"
        block
        onClick={signOut}
      >
        <FormattedMessage id="signOut" />
      </Button>
    </div>
  );
}

AcceptTerms.propTypes = {
  // TLDR: location.state.sourceLocation.pathname is a required string.
  sessionUser: PropTypes.shape({
    username: PropTypes.string.isRequired,
    termsToAccept: PropTypes.shape({
      termsOfUseToAccept: PropTypes.number,
      privacyPolicyToAccept: PropTypes.number,
      eulaToAccept: PropTypes.number,
    }),
  }),
  onSignOut: PropTypes.func.isRequired,
  acceptTermsAndConditions: PropTypes.func.isRequired,
  carouselRef: PropTypes.shape({ current: PropTypes.instanceOf(Carousel) }),
  loading: PropTypes.bool.isRequired,
};

AcceptTerms.defaultProps = {
  sessionUser: null,
  carouselRef: React.createRef(),
};

const mapStateToProps = (state) => {
  const continueRequest = selectAcceptTermsRequest(state);

  return {
    sessionUser: selectSessionUser(state),
    loading: continueRequest ? continueRequest.isLoading : false,
    continueError: continueRequest ? continueRequest.error : null,
  };
};

const mapDispatchToProps = dispatch => ({
  acceptTermsAndConditions: (termsOfUseAccepted, privacyPolicyAccepted, eulaAccepted, onFail) => {
    dispatch(requestAcceptTermsAndConditions(termsOfUseAccepted, privacyPolicyAccepted, eulaAccepted, onFail));
  },
  onSignOut: () => dispatch(requestSignOut()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AcceptTerms);
